import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VDataTable, {
    attrs: {
      "items": _vm.applications,
      "options": _vm.tableOptions,
      "headers": _vm.tableHeadersUI,
      "loading": _vm.isFetching,
      "footer-props": _vm.tableFooterProps,
      "item-key": "id"
    },
    on: {
      "update:options": function ($event) {
        _vm.tableOptions = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (items) {
        return [_c('tr', [_c('td', {
          staticClass: "px-0 text-center",
          staticStyle: {
            "width": "100px"
          }
        }, [_vm._v(_vm._s(items.item.applicationId))]), _c('td', {
          staticClass: "clickable",
          staticStyle: {
            "width": "40px"
          }
        }, [_c(VAvatar, {
          attrs: {
            "size": "30"
          }
        }, [items.item.applicationImage ? _c('img', {
          attrs: {
            "src": _vm.niota1ImageUrl(items.item.applicationImage)
          }
        }) : _c(VIcon, {
          attrs: {
            "small": "",
            "color": "white"
          }
        }, [_vm._v("fal fa-laptop")])], 1)], 1), _c('td', [_c('router-link', {
          attrs: {
            "to": `/niota-classic/applications/${items.item.applicationId}/details`
          }
        }, [_vm._v("\n            " + _vm._s(items.item.applicationTitle) + "\n          ")])], 1), _c('td', [_vm._v(_vm._s(_vm.localizeDate(items.item.applicationCreatedAt)))]), _vm.isIotHubManager ? _c('td', {
          staticClass: "text-right"
        }, [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "small": "",
            "title": "Delete"
          },
          on: {
            "click": function ($event) {
              return _vm.deleteLine(items.item);
            }
          }
        }, [_vm._v("fal fa-trash-alt")])], 1) : _vm._e()])];
      }
    }, {
      key: "footer.page-text",
      fn: function (items) {
        return [_vm._v("\n      " + _vm._s(items.pageStart) + "-" + _vm._s(items.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + " " + _vm._s(items.itemsLength) + "\n    ")];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n      ")])];
      },
      proxy: true
    }])
  }), _c(VDialog, {
    attrs: {
      "max-width": "500px"
    },
    model: {
      value: _vm.dialogAdd,
      callback: function ($$v) {
        _vm.dialogAdd = $$v;
      },
      expression: "dialogAdd"
    }
  }, [_c(VCard, [_c(VCardTitle, {
    staticClass: "text-h5"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Consumers.selectAppl')))]), _c(VCardText, [_c(VAutocomplete, {
    staticClass: "mt-4",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Consumers.chooseAppl'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.applicationsSelection,
      "item-text": "title",
      "item-value": "id",
      "hide-details": "auto",
      "return-object": "",
      "required": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (data) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(data.item.title))]), _c(VListItemSubtitle, [_vm._v("ID: " + _vm._s(data.item.id))])], 1)];
      }
    }]),
    model: {
      value: _vm.selectedApplication,
      callback: function ($$v) {
        _vm.selectedApplication = $$v;
      },
      expression: "selectedApplication"
    }
  })], 1), _c(VCardActions, [_c('core-button', {
    attrs: {
      "color": _vm.color
    },
    on: {
      "click": function ($event) {
        _vm.dialogAdd = false;
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.cancel')) + "\n        ")]), _c('core-button', {
    attrs: {
      "color": _vm.color
    },
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.ok')) + "\n        ")]), _c(VSpacer)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };